const ArrowOut = () => (
  <>
    <path
      fill="currentColor"
      d="m16.289 7.208-9.766 9.746a.44.44 0 0 1-.344.13.5.5 0 0 1-.345-.15.46.46 0 0 1-.14-.334q0-.194.14-.335L15.581 6.5H6.788a.48.48 0 0 1-.356-.144.49.49 0 0 1-.144-.357q0-.213.144-.356a.49.49 0 0 1 .356-.143h9.693q.343 0 .575.232a.78.78 0 0 1 .232.576V16q0 .212-.143.356a.49.49 0 0 1-.357.144.48.48 0 0 1-.356-.144.48.48 0 0 1-.143-.356z"
    />
  </>
)
export default ArrowOut
